<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
            <div class="section">

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                      <li><a @click="$router.push('/clients')">Chatbots</a></li>
                      <li><a @click="$router.push('/clients/'+client+'/intents')">{{clientName}}</a></li>
                      <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">{{intentName}}</a></li>
                      <li><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences')">{{sentenceName}}</a></li>
                      <li class="is-active"><a href="#" aria-current="page">Respuestas</a></li>
                    </ul>
                </nav>

                <div class="button is-primary is-left" @click="storeAnswer">
                    <span class="icon"><i class="fas fa-plus"></i></span>
                    <span class="is-capitalized">Nueva Respuesta</span>
                </div>
                <br><br>
                <table class="table is-striped is-fullwidth">

                    <thead>
                    <tr>
                        <th class="is-capitalized">Respuesta</th>
                        <th class="is-capitalized has-text-centered">Proceso</th>
                        <th class="table-button-column"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="answer in answers" :key="answer.id">
                      <td>{{answer.response}}</td>
                      <td class="has-text-centered">
                        <span v-if="answer.process" class="icon has-text-success">
                          <i class="fas fa-check"></i>
                        </span>
                      </td>
                      <td>
                        <div class="field has-addons">
                          <p class="control">
                            <a @click="updateAnswer(answer)"
                               class="button is-warning"
                               title="Editar">
                              <span class="icon"><i class="fas fa-edit"></i></span>
                            </a>
                          </p>
                          <p class="control">
                            <a @click="deleteAnswer(answer)"
                               class="button is-danger"
                               title="Eliminar">
                              <span class="icon"><i class="fas fa-trash-alt"></i></span>
                            </a>
                          </p>
                        </div>
                      </td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      sentence: this.$route.params.sentence,
      sentenceName: 'Frase',
      answers: {}
    }
  },
  created () {
    this.getAnswers()
    this.breadcrumbDetails()
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', {idIntent: this.$route.params.intent}).then(response => {
        this.intentName = response.intent.name
      })
      this.api.post('/PhraseById', {idDictionary: this.sentence}).then(response => {
        this.sentenceName = response.phrase.term
      })
    },
    go (uri) {
      let baseUrl = '/clients/' + this.client + '/intents/' + this.intent + '/sentences/' + this.sentence + '/answers/'
      this.$router.push(baseUrl + uri)
    },
    getAnswers () {
      this.api.post('/ResponseGetList', {idDictionary: this.sentence}).then(response => {
        this.answers = response.responses
      })
    },
    storeAnswer () {
      this.go('store')
    },
    updateAnswer (answer) {
      this.go(answer.idResponse + '/update')
    },
    deleteAnswer (answer) {
      let message = '¿Estás seguro de borrar esta respuesta?'

      this.dialog.confirm({message}).then(() => {
        this.api.post('/ResponseDelete', answer).then(() => {
          this.getAnswers()
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/answers/Answers.vue